<template>
  <div>
    <h1 class="pa-3 text-xs-center">Aktuelle Tabelle</h1>
    <v-data-table
      :headers="headers"
      :items="teams"
      :pagination.sync="pagination"
      :total-items="teams.length"
      hide-actions
      light
      class="elevation-3 table-of-bayernliga"
    >
      <template
        slot="items"
        slot-scope="props">
        <td class="position">&nbsp;</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.points }}</td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
export default {
  name: 'ElilScoreBoard',
  data() {
    return {
      pagination: {
        sortBy: 'points',
      },
      headers: [
        {
          text: 'Platz',
          value: 'position',
          class: 'headline',
          sortable: false,
        },
        {
          text: 'Verein',
          value: 'name',
          class: 'headline',
          sortable: false,
        },
        {
          text: 'Punkte',
          value: 'points',
          class: 'headline',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    teams() {
      return this.$store.getters.tableData;
    },
  },
};
</script>


<style lang="scss" scoped>
  .table-of-bayernliga {
    counter-reset: section;
    margin: 10px;

    tr:nth-child(2n) {
      td {
        background: rgba(33, 150, 243, 0.36);
      }
    }
  }

  .position::before {
    counter-increment: section; /* Increment the value of section counter by 1 */
    content: counter(section); /* Display the value of section counter */
  }
</style>



// WEBPACK FOOTER //
// src/components/ElilScoreBoard.vue